import Vue from 'vue'
import { init, captureException, captureMessage, setUser, addBreadcrumb, browserTracingIntegration } from '@sentry/vue'

import { User } from 'oidc-client'
import router from '@/router/router'

export class SentryPlugin {
	static init() {
		init({
			Vue: Vue,
			dsn: 'https://def588a7193c4871a487c3a475e9edf0@o105464.ingest.sentry.io/4505669357142016',
			autoSessionTracking: true,
			integrations: [browserTracingIntegration({ router })],
			debug: false,
			tracesSampleRate: 0.3,
			tracingOptions: {
				trackComponents: true
			},
			environment: import.meta.env.MODE
		})
	}

	static sendMessage(message: string) {
		if (import.meta.env.DEV) return
		captureMessage(message)
	}

	static sendException(exception: any, opts: any = {}) {
		if (import.meta.env.DEV) return
		captureException(exception, opts)
	}

	static setUser(user: User) {
		if (import.meta.env.DEV) return
		setUser(user)
	}

	static addBreadcrumb(obj: any) {
		if (import.meta.env.DEV) return
		addBreadcrumb(obj)
	}
}
